/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import { isEmoji, noAvatar } from "../../Components/Functions";
import { updateChatHistory, updateChatHistoryView } from "../../Redux/Chats/actions";
import ChatLeftSide from "./ChatLeftSide";
import { useParams } from "react-router-dom";
import { routers } from "../../Constants/routers";




export const ChatBodyItemSystem = (props) => {
	return (
		<li className="divider-container">
			<div className="divider">
				<span>{props?.content?.text}</span>
			</div>
		</li>
	);
};

export const ChatBodyItemMsg = (props) => {
	return (
		<li className={props?.sender}>
			<div className="avatar">
				<img src={props?.avatar || noAvatar()} alt="" />
			</div>
			<div className="msg">
				<div className="msg-inner">
					<p style={ isEmoji(props?.content?.text) ? { fontSize: 45 } : {  }}>{props?.content?.text}</p>
				</div>
				<time>{props?.content?.time}</time>
			</div>
		</li>
	);
};

export const ItemSwitcher = (props) => {
	switch (props?.type) {
		case "system":
			return <ChatBodyItemSystem {...props} />;

		case "msg":
			return <ChatBodyItemMsg {...props} />;

		default:
			return <ChatBodyItemMsg {...props} />;
	}
};

// <li className="chat-loader">
// <div className="loader is-loading" />
// </li>

const ChatBody = (props) => {
    const chatbody = React.useRef(null)
	const COUNT = props?.chathistory?.count;
	const CHATS = props?.chathistory?.results || [];
	const [droploaded, setDroploaded] = React.useState(false);
	let { currentUser } = useParams();
    const scrollToLatest = () => {
		if(droploaded) {
			setDroploaded(false);
			return;
		}
        try {
			var m = chatbody?.current;
        	m.scrollTop = m?.scrollHeight || 0;
		} catch (error) {
			console.log(error)
		}
    }
   
    React.useEffect(() => {
        if(CHATS?.length > 0){
            setTimeout(() => {
                const view = chatbody.current;
                view.addEventListener("scroll", (e) => {
					if(currentUser !== routers.dashboard.newconversation.name){
						if(view.scrollTop === 0 && CHATS?.length < COUNT){
							setDroploaded(true);
							props.updateChatHistory(props?.chathistory, currentUser)
						}
					}else{
						props.updateChatHistoryView({ 
							results: [],
							user: null
						})
					}
                });
            }, 1500);
        }
    }, [CHATS])

	React.useEffect(() => {
		scrollToLatest();
	},[CHATS])

    

	return (
		<div className={`chat-body-wrap ${props?.collapse1 ? "side-collapsed" : ""}`} key={v4()}>
			<ol ref={chatbody} className="chat-body" key={v4()}>
                {props?.chathistory?.loading && (
                    <>
                    <li class="chat-loader is-active" key={v4()}>
                    	<div class="loader is-loading"></div>
                	</li>
                    </>
                )}
				{CHATS?.length > 0 ? (
					CHATS.map((e) => {
						return <ItemSwitcher key={v4()} {...e} />;
					})
				) : (
					<li className="no-messages" key={v4()}>
						<img
							className="light-image"
							src={require("../../assets/img/illustrations/placeholders/search-4.svg").default}
							alt=""
						/>
						<div className="text">
							<h3>No messages yet</h3>
							<p>Start the conversation by typing a message</p>
						</div>
					</li>
				)}
			</ol>
			<ChatLeftSide collapse1={props.collapse1} setCollapse1={props.setCollapse1} />
		</div>
	);
};

const mapStateToProps = ({ chathistory }) => {
	return { chathistory };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateChatHistory: (e, u) => dispatch(updateChatHistory(e, u)),
		updateChatHistoryView: (e) => dispatch(updateChatHistoryView(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatBody);
